import React, { useState, useRef, useEffect } from 'react';
import styles from './AddEdit.module.scss';
import CreateNewsHeader from '../../Molecules/Academic_E_G/AddEditHeader';
import folderIcon from '../../../assets/Imagess/folderICon.svg';
import uploadIcon from '../../../assets/Imagess/upload-icon.svg';
import hashIcon from '../../../assets/Imagess/hash.svg';
import * as Yup from 'yup';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../Constants';
import { toast } from 'react-toastify';
import './Quill.css';
import 'react-quill/dist/quill.snow.css';
import { useToast } from '../../Molecules/Custom/CustomToaster/Toast';
import { Field, Form, Formik } from 'formik';
import TextInput from '../../Atoms/Inputs/TextInput';
import fileIcon from '../../../assets/Imagess/file-icon-green.svg';
import closeIcon from '../../../assets/Imagess/close2.svg';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import DateInput from '../../Atoms/Inputs/DateInput';
const calendarIcon = (
  <svg
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Group 20956'>
      <path
        id='Vector'
        d='M5.43428 0C5.89173 0 6.26256 0.356629 6.26256 0.79655V2.40335C6.99725 2.38964 7.82078 2.38964 8.74737 2.38964H13.1648C14.0914 2.38964 14.9149 2.38964 15.6496 2.40335V0.79655C15.6496 0.356629 16.0204 0 16.4779 0C16.9353 0 17.3062 0.356629 17.3062 0.79655V2.47382C18.8957 2.59623 19.9393 2.89665 20.7059 3.63393C21.4726 4.37121 21.785 5.37475 21.9122 6.90341L21.9999 7.69996H1.01701H0V6.90341C0.12728 5.37475 0.439668 4.37121 1.20631 3.63393C1.97296 2.89665 3.01647 2.59623 4.60601 2.47382V0.79655C4.60601 0.356629 4.97684 0 5.43428 0Z'
        fill='#A9A7A7'
      />
      <path
        id='Vector_2'
        d='M22 14.0001V12.0001C22 11.161 21.9965 9.66526 21.9823 9H0.0110106C-0.00319018 9.66526 0.000406649 11.161 0.000406649 12.0001V14.0001C0.000406649 17.7712 0.000406628 19.6568 1.28911 20.8284C2.57782 22 4.65196 22 8.80026 22H13.2002C17.3485 22 19.4226 22 20.7114 20.8284C22 19.6568 22 17.7712 22 14.0001Z'
        fill='#A9A7A7'
      />
    </g>
  </svg>
);

const CreateEvent = ({
  setAddEditMode,
  selectedEchoMagazine,
  type,
  addEditMode,
  setMoveRight,
  moveRight,
}) => {
  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);
  const customizedToast = useToast();
  const [FileName, setFileName] = useState();
  const [ImgSrc, setImgSrc] = useState('');

  const handleUploadImageClick = () => {
    fileInputRef.current.click();
  };

  const handleUploadImageClick2 = () => {
    fileInputRef2.current.click();
  };

  const createEchoMagazine = useMutation({
    mutationFn: (fields) => {
      // return axios.post(API_URL + `/api/EchoMagazine/PostEchoMagazine`, fields);
      return axios.post(
        API_URL + `/api/EchoMagazine/PostEchoMagazine`,
        fields,
        {
          headers: securityHeaders,
        }
      );
    },
    onSuccess: (data) => {
      customizedToast.open(
        selectedEchoMagazine == null ? 'تم الإنشاء بنجاح' : 'تم التحديث بنجاح'
      );
      setTimeout(() => {
        setAddEditMode(null);
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });
  const initialValues = {
    Title_AR: selectedEchoMagazine ? selectedEchoMagazine.title_AR : '',
    MagazineDate: selectedEchoMagazine
      ? new Date(selectedEchoMagazine.magazineDate)
      : '',
    EditionNumber: selectedEchoMagazine
      ? selectedEchoMagazine.editionNumber
      : '',
    PageNumber: selectedEchoMagazine ? selectedEchoMagazine.pageNumber : '',
    MagazineThumbnail: selectedEchoMagazine
      ? selectedEchoMagazine.url + selectedEchoMagazine.magazineThumbnail
      : null,
    Magazine: selectedEchoMagazine
      ? selectedEchoMagazine.url + selectedEchoMagazine.magazineBlob
      : null,
  };

  const validationSchema = Yup.object().shape({
    Title_AR: Yup.string().required('مطلوب تعبئته'),
    MagazineDate: Yup.date().required('مطلوب تعبئته'),
    EditionNumber: Yup.string().required('مطلوب تعبئته'),
    PageNumber: Yup.string().required('مطلوب تعبئته'),
    Magazine: Yup.mixed().required('Image is required'),
    MagazineThumbnail: Yup.mixed().required('File is required'),
  });
  useEffect(() => {
    setImgSrc(
      selectedEchoMagazine?.url + selectedEchoMagazine?.magazineThumbnail
    );
  }, [selectedEchoMagazine]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const formData = new FormData();
        formData.append(
          'MagazineId',
          selectedEchoMagazine
            ? selectedEchoMagazine.magazineId
            : '00000000-0000-0000-0000-000000000000'
        );
        formData.append('Title_AR', values.Title_AR);
        formData.append(
          'MagazineDate',
          moment(values.MagazineDate).format('YYYY-MM-DD')
        );
        formData.append('EditionNumber', values.EditionNumber);
        formData.append('PageNumber', values.PageNumber);
        formData.append('Magazine', values.Magazine);
        formData.append('MagazineThumbnail', values.MagazineThumbnail);
        formData.append('Type', parseFloat(type));
        formData.append(
          'AcademicYearId',
          '62B02A29-E9D2-463D-93EB-A75622983565'
        );
        createEchoMagazine.mutate(formData);
      }}
    >
      {({ errors, touched, values, setFieldValue, handleSubmit }) => {
        const handleFileChange = (event) => {
          const file = event.currentTarget.files[0];
          if (file && file.type === 'application/pdf') {
            setFieldValue('Magazine', file);
          } else {
            setFieldValue('Magazine', null);
            toast.error('Please upload a valid PDF file.');
          }
        };
        const handleImageChange = (event) => {
          const file = event.currentTarget.files[0];
          const allowedTypes = ['image/png', 'image/jpeg', 'image/svg+xml'];
          if (file && allowedTypes.includes(file.type)) {
            setFieldValue('MagazineThumbnail', file);
            setImgSrc(URL.createObjectURL(file));
          } else {
            setFieldValue('MagazineThumbnail', null);
            toast.error('Only [PNG, JPG, SVG] Files ');
          }
        };
        return (
          <Form>
            <div className={styles['action-programs']}>
              <div className={styles['container']}>
                <CreateNewsHeader
                  handleSubmit={handleSubmit}
                  title={addEditMode ? 'رفع مجلة جديدة' : 'تعديل '}
                  setAddEditMode={setAddEditMode}
                  moveRight={moveRight}
                />
              </div>{' '}
              <div
                className={styles['container']}
                style={{ paddingTop: '0px' }}
              >
                <div className={styles['steps']}>
                  <div className={styles['step-container']}>
                    <div
                      className={`${styles['step-container']}`}
                      style={{ display: 'block' }}
                    >
                      <TextInput
                        label='اسم المجلة'
                        placeholder='أدخل الاسم'
                        icon={folderIcon}
                        value={values.Title_AR}
                        name='Title_AR'
                        onChange={(name, value) => {
                          setFieldValue(name, value);
                        }}
                        errors={errors.Title_AR}
                        touched={touched.Title_AR}
                        left
                      />
                    </div>
                    <div className={styles['step-row']}>
                      <DateInput
                        label='تاريخ النشر'
                        placeholder='أدخل تاريخ النشر'
                        showIcon
                        value={values.MagazineDate}
                        name='MagazineDate'
                        onChange={setFieldValue}
                        dateFormat='yyyy-MM-dd'
                        errors={errors.MagazineDate}
                        touched={touched.MagazineDate}
                      />
                      <TextInput
                        label='رقم الإصدار'
                        placeholder='أدخل رقم الإصدار'
                        icon={hashIcon}
                        name='EditionNumber'
                        value={values.EditionNumber}
                        onChange={(name, value) => {
                          setFieldValue(name, value);
                        }}
                        errors={errors.EditionNumber}
                        touched={touched.EditionNumber}
                      />
                    </div>
                    <TextInput
                      label='عدد الصفحات'
                      placeholder='أدخل عدد الصفحات'
                      icon={hashIcon}
                      name='PageNumber'
                      value={values.PageNumber}
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                      }}
                      errors={errors.PageNumber}
                      touched={touched.PageNumber}
                    />
                  </div>
                </div>
              </div>
              <div
                className={styles['container']}
                style={{ paddingTop: '30px' }}
              >
                <div className={styles['upload-row']}>
                  <div className={styles['w-50']}>
                    <label className={styles['upload-label']}>
                      رفع الصورة المصغرة
                    </label>
                    {errors.MagazineThumbnail && touched.MagazineThumbnail ? (
                      <p style={{ color: 'red' }}>اختر صورة للرفع</p>
                    ) : (
                      ''
                    )}
                    <Field name='MagazineThumbnail'>
                      {({ field }) =>
                        field.value ? (
                          <div
                            className={styles['upload-container']}
                            onClick={handleUploadImageClick}
                          >
                            <img src={ImgSrc} alt='selected-image' />
                          </div>
                        ) : (
                          <div
                            className={styles['upload-container']}
                            onClick={handleUploadImageClick}
                          >
                            <div className={styles['upload-icon-container']}>
                              <img
                                className={styles['upload-icon']}
                                src={uploadIcon}
                              />
                              <div className={styles['text-container']}>
                                <p className={styles['select-image']}>
                                  اختر صورة للرفع
                                </p>
                                <p className={styles['size']}>
                                  الحد الأقصى للحجم:{' '}
                                  <span dir='ltr'>100 MB</span>{' '}
                                </p>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    </Field>
                  </div>

                  <div className={styles['w-50']}>
                    <label className={styles['upload-label']}>
                      {type === 0 ? 'رفع المجلة' : 'رفع الإرشادات'}
                    </label>
                    {errors.Magazine && touched.Magazine ? (
                      <p style={{ color: 'red' }}>اختر ملف للرفع</p>
                    ) : (
                      ''
                    )}
                    <Field name='Magazine'>
                      {({ field }) =>
                        field.value ? (
                          <div className={styles['uploaded-item-container']}>
                            <div className={styles['file-name-container']}>
                              <img src={fileIcon} />
                              <p className={styles['file-name']}>
                                {field.value.name || 'Pdf'}
                              </p>
                            </div>
                            <img
                              style={{ cursor: 'pointer' }}
                              src={closeIcon}
                              onClick={() => setFieldValue('Magazine', null)}
                            />
                          </div>
                        ) : (
                          <div
                            className={styles['upload-container']}
                            onClick={handleUploadImageClick2}
                          >
                            <div className={styles['upload-icon-container']}>
                              <img
                                className={styles['upload-icon']}
                                src={uploadIcon}
                              />
                              <div className={styles['text-container']}>
                                <p className={styles['select-image']}>
                                  اختر ملف للرفع
                                </p>
                                <p className={styles['size']}>
                                  الحد الأقصى للحجم:{' '}
                                  <span dir='ltr'>100 MB</span>{' '}
                                </p>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    </Field>
                  </div>
                </div>

                <input
                  type='file'
                  className='form-control form-body-input'
                  style={{ display: 'none' }}
                  accept='image/*'
                  ref={fileInputRef}
                  onChange={handleImageChange}
                  required
                />
                <input
                  type='file'
                  className='form-control form-body-input'
                  style={{ display: 'none' }}
                  ref={fileInputRef2}
                  accept='.pdf' // Restricts the file input to only accept PDF files
                  onChange={handleFileChange}
                  required
                />
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateEvent;
